import actions from './actions'

const initialState = {
  loading: false,
  businessTypes: [
    {
      name: 'Retail',
    },
    {
      name: 'Restaurant',
    },
    {
      name: 'Spa/Salon',
    },
    {
      name: 'Coffee Shop',
    },
    {
      name: 'Automotive',
    },
    {
      name: 'E-commerce Store',
    },
    {
      name: 'Grocery',
    },
    {
      name: 'Vape Store',
    },
    {
      name: 'Pet Shop',
    },
    {
      name: 'Boutique',
    },
    {
      name: 'Other',
    },
  ],
}

export default function userReducer(state = initialState, action) {
  switch (action.type) {
    case actions.SET_STATE:
      return { ...state, ...action.payload }
    case actions.SET_BUSINES_TYPES:
      return { ...state, ...action?.payload?.businessTypes }
    default:
      return state
  }
}
